var styles = {
  "Tag": "Polaris-Tag",
  "disabled": "Polaris-Tag--disabled",
  "clickable": "Polaris-Tag--clickable",
  "linkable": "Polaris-Tag--linkable",
  "removable": "Polaris-Tag--removable",
  "Button": "Polaris-Tag__Button",
  "Link": "Polaris-Tag__Link",
  "segmented": "Polaris-Tag--segmented",
  "Text": "Polaris-Tag__Text",
  "sizeLarge": "Polaris-Tag--sizeLarge",
  "overlay": "Polaris-Tag--overlay"
};

export { styles as default };
